import createClient, { type Middleware } from 'openapi-fetch'

import { useAppConfigStore } from '@/stores/app-store-config/appConfigStore'
import type { paths } from '@/types/v1'

const throwOnError: Middleware = {
	async onResponse(res) {
		if (res.status >= 400) {
			const body = res.headers.get('content-type')?.includes('json')
				? await res.clone().json()
				: await res.clone().text()
			throw new Error(body)
		}
		return undefined
	},
}

const { rootUri } = useAppConfigStore.getState()

export const client = createClient<paths>({ baseUrl: rootUri })

client.use(throwOnError)
